import { Link } from "react-router-dom";
import { Seo } from "../../components/Seo";
import { useLanguage } from "../../i18n/LanguageProvider";

export const NotFoundPage = () => {
  const { t, path } = useLanguage();

  return (
    <>
      {/* noIndex so a mistyped URL cannot end up in search results. */}
      <Seo
        titleKey="meta.notFound.title"
        descriptionKey="meta.notFound.description"
        noIndex
      />

      <section className="gw-section">
        <div
          className="gw-container gw-container--narrow"
          style={{ textAlign: "center" }}
        >
          <p className="gw-eyebrow" style={{ justifyContent: "center" }}>
            404
          </p>
          <h1 className="gw-title">{t("errors.notFoundTitle")}</h1>
          <p className="gw-subtitle" style={{ marginInline: "auto" }}>
            {t("errors.notFoundBody")}
          </p>
          <p style={{ marginTop: "2rem" }}>
            <Link to={path("/")} className="gw-btn gw-btn--primary">
              {t("errors.notFoundAction")}
            </Link>
          </p>
        </div>
      </section>
    </>
  );
};
